<template>
  <div class="full-page">
    <van-action-sheet 
      v-model="open" 
      :class="attrs.className" 
      v-bind="attrs">
      <div class="select-wrapper">
        <div class="select-box" v-for="(item, index) in list" :key="index">
          <div class="select-item van-ellipsis" 
            @click="choiceRelationship(item)" 
            :class="{'active': relation === item}">
            {{item}}
          </div>
        </div>
        <div class="select-box" style="width: 66.66%">
          <div class="select-item " @click="showCustomRelationship=true">
            自定义关系
          </div>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog 
      v-model="showCustomRelationship" 
      title="自定义关系" 
      show-cancel-button 
      @confirm="confirmCustom"
      teleport="body" 
      @opened="focusInput">
      <div class="dialog-wrapper" style="margin: 20px 16px;">
        <van-field v-model="customRelationship" placeholder="请输入自定义关系" maxlength="10" ref="relationInput"/>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'Relation',
  data() {
    return {
      open: false,
      list: ['本人','爸爸','妈妈','爷爷','奶奶','外公','外婆'],
      relation: '',
      customRelationship: '',
      showCustomRelationship: false,
      attrs: {},
    };
  },
  methods: {
    showPicker(relation, opts) {
      return new Promise((resolve) => {
        if (relation && this.list && !this.list.find(v=>v===relation)) {
          this.list.push(relation)
        }
        this.wrapshow = true;
        this.open = true;
        this.relation = relation
        this.attrs = {...opts}
        this._resolve = resolve;
      });
    },
    choiceRelationship(item) {
      this.relation = item;

      this.open = false;

      this._resolve(item);
    },
    confirmCustom() {
      let relation = this.customRelationship
      if (relation && this.list && !this.list.find(v=>v===relation)) {
        this.list.push(relation)
      }
      this.choiceRelationship(relation)
      this.customRelationship = ''
    },
    focusInput() {
      this.$refs.relationInput.focus();
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
  .select-wrapper {
    font-size: var(--fs-md);
    display: flex;
    flex-wrap: wrap;
    margin: 16px 8px 48px 8px;
    text-align: center;
    .select-box {
      width: 33.33%;
      height: 48px;
      padding: 8px;
      .select-item {
        padding: 0 6px;
        line-height: 32px;
        border-radius: 16px;
        background-color: var(--g1);
        &.active {
          color: var(--white);
          background-color: var(--c1);
        }
        >input {
          border: none;
          background-color: #f7f8fa;
          text-align: center;
        }
      }
    }
  }
</style>
